<template>
  <div
    :style="{ width: width + 'px', height: height + 'px' }"
    class="post-default-thumbnail"
  >
    <!-- <v-icon class="icon">pets</v-icon> -->
    <svg viewBox="0 0 100 180" width="30" height="100">
     <g id="layer1" transform="translate(0 -872.36)">
      <path id="path3006" d="m81.951 948.64a31.484 31.484 0 0 1 -24.826 36.77 31.484 31.484 0 0 1 -36.946 -24.57 31.484 31.484 0 0 1 24.322 -37.11 31.484 31.484 0 0 1 37.278 24.06" fill-opacity="0" stroke-linecap="square" stroke-width="7.0212"/>
      <g stroke-linecap="round" fill="none">
       <path id="path3813" stroke-linejoin="round" d="m21.024 994.53c20 20 30 40 30 40s5-15 40-60" stroke-width="7"/>
       <g>
        <g stroke-width="5">
         <path id="path3815" d="m34.922 905.92 3.6071 9.6429"/>
         <path id="path3815-6" d="m88.405 919.62-7.9596 6.53"/>
         <path id="path3815-68" d="m19.384 904.54 9.8526 15.99"/>
        </g>
        <path id="path3815-68-0" d="m44.864 894.81 2.0941 19.271" stroke-width="4.6015"/>
        <g stroke-width="5">
         <path id="path3815-9" d="m68.413 906.8-2.5135 9.9839"/>
         <path id="path3815-68-9" d="m59.23 899.4-2.1672 14.737"/>
         <path id="path3815-6-6" d="m14.65 919.04 7.4532 7.1025"/>
         <path id="path3815-1" d="m81.891 907.81-8.0193 12.761"/>
        </g>
       </g>
      </g>
     </g>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'PostDefaultThumbnail',
  props: {
    width: {
      default: 200,
    },
  },
  computed: {
    height() {
      return Math.round(this.width / 1.777);
    },
  },
};

</script>

<style scoped>

.post-default-thumbnail {
  /*border: solid 1px rgba(0,0,0, .4);*/
  background: rgba(0,0,0,.04);
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  font-size: 60px;
}

svg {
  stroke: rgba(0,0,0, .2);
}

</style>



// WEBPACK FOOTER //
// src/components/PostDefaultThumbnail.vue